// extracted by mini-css-extract-plugin
module.exports = {"statsWrapper":"BadgeStats_statsWrapper__LH55z","scrollWrapper":"BadgeStats_scrollWrapper__1Xsyr"};